import React from 'react'
import { Stack, Tooltip, Typography } from '@mui/material'
import { Tag } from '../Tag'
import { useAudienceColor } from '../../hooks/useAudienceColor'
import { NO_VALUE_LABEL } from '../../utils/displayValue'

type AudienceTagsProps = {
    audiences?: string[]
    maxVisible?: number
}

export const AudienceTags = ({ audiences = [], maxVisible = Infinity }: AudienceTagsProps) => {
    const getAudienceColor = useAudienceColor()

    if (!audiences.length) {
        return (
            <Typography variant="14x400" color="figma.grayscale.textHier2">
                {NO_VALUE_LABEL}
            </Typography>
        )
    }

    const visible = audiences.slice(0, maxVisible)
    const hidden = audiences.slice(maxVisible)

    return (
        <Stack direction="row" flexWrap="nowrap" gap={0.5}>
            {visible.map((audience) => (
                <Tag key={audience} label={audience} backgroundColor={getAudienceColor(audience)} />
            ))}
            {!!hidden.length && (
                <Tooltip title={hidden.join(', ')}>
                    <span>
                        <Tag
                            label={`+${hidden.length}`}
                            color="figma.grayscale.textHier2"
                            backgroundColor="figma.grayscale.tier6"
                        />
                    </span>
                </Tooltip>
            )}
        </Stack>
    )
}

export default AudienceTags
